import { MutableRefObject } from 'react';
import { AnyAction } from 'redux';

import { MediaBreakpoint } from 'craft/types';

import {
  SET_DOCUMENT_DOM,
  SET_SCROLLABLE_BODY_DOM,
  SET_TOOLBOX_STATE,
  SET_VIEWPORT_BREAKPOINT,
  SET_VIEWPORT_CONTAINER_DOM,
  SET_VIEWPORT_CONTENT_DOM,
  SET_VIEWPORT_WRAPPER_DOM,
} from './constants';

export interface ViewportDomState {
  viewportContainerRef?: MutableRefObject<HTMLElement | null>;
  viewportContentRef?: MutableRefObject<HTMLElement | null>;
  viewportWrapperRef?: MutableRefObject<HTMLElement | null>;
  documentRef?: MutableRefObject<HTMLElement | null>;
  scrollableBodyRef?: MutableRefObject<HTMLElement | null>;
}

export interface ViewportState extends ViewportDomState {
  breakpoint: MediaBreakpoint;
  isToolboxDocked: boolean | null;
}

const initialState: ViewportState = {
  breakpoint: MediaBreakpoint.LG,
  viewportContainerRef: undefined,
  viewportContentRef: undefined,
  viewportWrapperRef: undefined,
  documentRef: undefined,
  scrollableBodyRef: undefined,
  isToolboxDocked: null,
};

export const viewportReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case SET_VIEWPORT_BREAKPOINT:
      return { ...state, breakpoint: action.breakpoint };
    case SET_VIEWPORT_CONTAINER_DOM:
      return { ...state, viewportContainerRef: action.viewportContainerRef };
    case SET_VIEWPORT_CONTENT_DOM:
      return { ...state, viewportContentRef: action.viewportContentRef };
    case SET_VIEWPORT_WRAPPER_DOM:
      return { ...state, viewportWrapperRef: action.viewportWrapperRef };
    case SET_DOCUMENT_DOM:
      return { ...state, documentRef: action.documentRef };
    case SET_SCROLLABLE_BODY_DOM:
      return { ...state, scrollableBodyRef: action.scrollableBodyRef };
    case SET_TOOLBOX_STATE:
      return { ...state, isToolboxDocked: action.isDocked };

    default:
      return state;
  }
};
